import { render, staticRenderFns } from "./btn-radio.vue?vue&type=template&id=16c1db5d"
import script from "./btn-radio.vue?vue&type=script&lang=js"
export * from "./btn-radio.vue?vue&type=script&lang=js"
import style0 from "./btn-radio.vue?vue&type=style&index=0&id=16c1db5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports